import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ProductTaxationWizard = lazy(() => import(/* webpackChunkName: "ProductTaxationWizard" */ './components/ProductTaxationWizard'));

const productTaxationWizards = Array.from(document.querySelectorAll('#product-taxation-wizard'));
if (productTaxationWizards != null) {
    productTaxationWizards.forEach(productTaxationWizard => {
        const props = parseDatasetToProps(productTaxationWizard.dataset);

        render(
            <Suspense fallback={<></>}>
                <ProductTaxationWizard
                    {...props}
                />
            </Suspense>,
            productTaxationWizard
        );
    })
}
